<app-header [forceLightBackground]="true"></app-header>

<section class="user-manual-section">
  <div class="user-manual-section__page">
    @if (assetHeaderConfig) {
      <app-asset-header [config]="assetHeaderConfig"></app-asset-header>
    }

    <div class="user-manual-section__layout">
      <aside class="user-manual-section__sidebar">
        <div class="manual-sidebar__section">
          <div class="manual-sidebar__section-header">
            <h3 class="manual-sidebar__title">Sections</h3>
          </div>
          <ul class="manual-sidebar__list">
            @for (sec of level1Sections; track sec.id) {
              <li
                class="manual-sidebar__item"
                [class.manual-sidebar__item--active]="topSection?.id === sec.id"
              >
                <button type="button" class="manual-sidebar__link" (click)="openSection(sec.id)">
                  {{ sec.title }}
                </button>
              </li>
            }
          </ul>
        </div>
      </aside>

      <main class="user-manual-section__main">
        @if (topSection) {
          <h1 class="manual-section__level1-title">{{ topSection.title }}</h1>
          @if (topSection.content.length || topSection.contentBlocks?.length) {
            <div class="manual-section-body">
              @if (topSection.contentBlocks?.length) {
                @for (block of topSection.contentBlocks!; track $index) {
                  @if (block.type === 'text') {
                    <p
                      class="manual-section__para"
                      [class.manual-section__list-line--1]="block.indent === 1"
                      [class.manual-section__list-line--2]="block.indent === 2"
                      [class.manual-section__list-line--3]="block.indent === 3"
                      [innerHTML]="block.text | manualBoldLabels"
                    ></p>
                  } @else if (block.type === 'figure') {
                    <figure class="manual-figure">
                      @if (block.image) {
                        <img
                          [src]="block.image"
                          [alt]="block.caption"
                          class="manual-figure__img"
                          loading="lazy"
                        />
                      }
                      <figcaption class="manual-figure__caption">{{ block.caption }}</figcaption>
                    </figure>
                  }
                }
              } @else {
                @for (para of topSection.content; track $index) {
                  <p class="manual-section__para" [innerHTML]="para | manualBoldLabels"></p>
                }
              }
            </div>
          }

          @for (sec of subSections; track sec.id) {
            <div class="manual-subsection">
              <h2 class="manual-subsection__title">{{ sec.title }}</h2>
              @if (hasSubsectionBody(sec)) {
                <div class="manual-subsection__body">
                  @if (sec.contentBlocks?.length) {
                    @for (block of sec.contentBlocks!; track $index) {
                      @if (block.type === 'text') {
                        <p
                          class="manual-section__para"
                          [class.manual-section__list-line--1]="block.indent === 1"
                          [class.manual-section__list-line--2]="block.indent === 2"
                          [class.manual-section__list-line--3]="block.indent === 3"
                          [innerHTML]="block.text | manualBoldLabels"
                        ></p>
                      } @else if (block.type === 'figure') {
                        <figure class="manual-figure">
                          @if (block.image) {
                            <img
                              [src]="block.image"
                              [alt]="block.caption"
                              class="manual-figure__img"
                              loading="lazy"
                            />
                          }
                          <figcaption class="manual-figure__caption">{{ block.caption }}</figcaption>
                        </figure>
                      }
                    }
                  } @else {
                    @for (para of sec.content; track $index) {
                      <p
                        class="manual-section__para"
                        [class.manual-section__step-label]="sec.id === 'about-manual' && ($index === 1 || $index === 3)"
                        [innerHTML]="para | manualBoldLabels"
                      ></p>
                    }
                    @if (sec.figures?.length) {
                      <div class="manual-section__figures">
                        @for (fig of sec.figures!; track $index) {
                          <figure class="manual-figure">
                            @if (fig.image) {
                              <img
                                [src]="fig.image"
                                [alt]="fig.caption"
                                class="manual-figure__img"
                                loading="lazy"
                              />
                            }
                            <figcaption class="manual-figure__caption">{{ fig.caption }}</figcaption>
                          </figure>
                        }
                      </div>
                    }
                  }
                  @if (sec.roleAudienceTable?.length) {
                    <app-manual-role-audience-table [rows]="sec.roleAudienceTable!" />
                  }
                </div>
              }
            </div>
          }
        } @else {
          <div class="not-found">Section not found.</div>
        }
      </main>
    </div>
  </div>
</section>

<app-footer></app-footer>
